export default __webpack_public_path__ + "static/media/criacao-servico.b37ead2c.png";